const portalColorSequence = ['purple', 'blue', 'yellow', 'green', 'pink'];

const badgeThresholds = [10, 50, 100, 300, 450, 650, 850, 1000, 1250];

export {badgeThresholds, portalColorSequence};
